import React, { Component } from "react";

import LodgingCell from "./lodgingCell";
import ActivityCell from "./activityCell";

export default class Units extends Component {
  render() {
    const { props } = this;
    const { date, noResults, units, onCtaClick, ctaText, buttonStyle, loading, supplier, language, title, secondaryButtonStyle, disabledText, noSearch } = props;

    const isActivityOrRestaurant = supplier.type === "activity" || supplier.type === "restaurant"

    if (!units || units.length === 0) {
      return (
        <div id={title} className="p-6" >
         {noResults}
        </div>
      )
    }
    return (
      <div className="relative" id={title}>
        {loading ? <div className="absolute top-0 bottom-0 right-0 left-0 bg-white opacity-50 backdrop-filter: blur(10px) z-10"></div> : null}
        {
           units.map((unit, index) => {
            const isLast = units.length === index + 1;
            const isFirst = index === 0;
            if (!unit.product_uuid) return;
            const disabled = (!unit.product_uuid.availability && !noSearch && !loading);
            return (
              <div key={`unit_${index}`} className={`px-6 ${disabled && !isActivityOrRestaurant ? "bg-gray-200": ""} ${!isLast ? "border-b-2 border-gray-200" : ""} ${isFirst ? "pb-4" : "py-4" }`}>
                {
                  isActivityOrRestaurant ?
                  <ActivityCell
                    date={date}
                    loading={loading}
                    unit={unit.product_uuid}
                    index={index}
                    onCtaClick={onCtaClick}
                    buttonStyle={buttonStyle}
                    supplier={supplier}
                    language={language}
                    secondaryButtonStyle={secondaryButtonStyle}
                  />
                  :
                  <LodgingCell
                    disabled={disabled}
                    isHotel={supplier.type === "hotel"}
                    language={language}
                    unit={unit.product_uuid}
                    index={index}
                    onCtaClick={onCtaClick}
                    disabledText={disabledText}
                    ctaText={ctaText}
                    buttonStyle={buttonStyle}
                  />
                }
              </div>
            )
          })
        }
      </div>
    )
  }
}